import { SHORT_BUFF_NAMES, ICON_SIZE, ICON_URL, BUILDING_NAMES, MULT_CLICK_IDS, } from "../constants";
import { globalVars } from "../globalVariables";
import { settings } from "../settings/settings";
import { getQT } from "./dom";
import { highlightInfoBlock } from "./highlightInfoBlock";
const getId = (buff) => {
    const { type: buffType, arg2 } = buff;
    const { name: buffTypeName } = buffType;
    const buffId = buffTypeName.includes("building")
        ? `${buffTypeName}_${arg2}`
        : buffTypeName;
    return buffId.replaceAll(" ", "_");
};
const getBuildingName = (buff) => {
    const { arg2 } = buff;
    if (arg2 === undefined)
        return "";
    return BUILDING_NAMES[arg2];
};
const getName = (buff) => {
    const buffId = getId(buff);
    let buffName;
    if (!settings.shortBuffNames) {
        buffName = buff?.name;
    }
    else if (buffId.includes("building_buff")) {
        buffName = "BS";
    }
    else if (buffId.includes("building_debuff")) {
        buffName = "Rust";
    }
    else {
        buffName = SHORT_BUFF_NAMES[buffId] || buff?.name;
    }
    if (settings.showBuildingName && buffId.includes("building")) {
        buffName += ` (${getBuildingName(buff)})`;
    }
    return buffName;
};
const getIcon = (buff) => {
    const { icon } = buff;
    const size = settings.guiScale * ICON_SIZE;
    const backgroundPos = `${-icon[0] * size}px ${-icon[1] * size}px`;
    const backgroundSize = `${36 * size}px`;
    return `
    <div style="width: ${size}px; height: ${size}px; background-image: url(${ICON_URL}); background-size: ${backgroundSize}; background-position: ${backgroundPos}"></div>
  `;
};
const getMultiplier = (buff) => {
    const buffId = getId(buff);
    return (MULT_CLICK_IDS.includes(buffId) ? buff.multClick : buff.multCpS) || 1;
};
const clearTimers = () => {
    globalVars.buffTimers.forEach(({ id }) => {
        getQT(id)?.remove();
    });
    globalVars.buffTimers = [];
};
const highlightExistingBuff = (oldBuffTimers, newBuff) => {
    const newBuffId = getId(newBuff);
    const oldBuffCandidate = oldBuffTimers.find((buff) => buff.id === newBuffId);
    if (oldBuffCandidate) {
        highlightInfoBlock(getQT(oldBuffCandidate.id));
    }
};
export const BuffUtils = {
    getId,
    getName,
    getIcon,
    getBuildingName,
    getMultiplier,
    clearTimers,
    highlightExistingBuff,
};
